module.exports = __webpack_public_path__ + "img/child-song1.8d2c0d8c.png";